import { render, staticRenderFns } from "./materialClouds.vue?vue&type=template&id=1850cb7b&scoped=true&"
import script from "./materialClouds.vue?vue&type=script&lang=js&"
export * from "./materialClouds.vue?vue&type=script&lang=js&"
import style0 from "./materialClouds.vue?vue&type=style&index=0&id=1850cb7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1850cb7b",
  null
  
)

export default component.exports